import { TCommonData, TCommonWidgetValue, TItem, TWidget } from '@libs/types';
import { nanoid } from '@reduxjs/toolkit';

const getValueFromItem = (item: Record<string, TCommonWidgetValue>, key: string) => {
    return item[key.slice(1)];
};

export const fillTemplate = (item: TItem, templates: Record<string, Array<TWidget<TCommonData>>>) => {
    const cloneTemplate = structuredClone(templates[item.templateId ?? 'default']);
    return fillTemplateInner(item, cloneTemplate);
};
export const parseTemplates = (template: Array<TWidget<TCommonData>>): Record<string, Array<TWidget<TCommonData>>> => {
    const isArray = Array.isArray(template);
    const result: Record<string, Array<TWidget<TCommonData>>> = {
        default: isArray ? template : [template],
    };
    if (isArray) {
        template.filter((t) => t.templateId).forEach((t) => (result[t.templateId ?? 'default'] = [t]));
    }
    return result;
};
const fillTemplateInner = (item: Record<string, TCommonWidgetValue>, template?: Array<TWidget<TCommonData>> | TWidget<TCommonData>) => {
    if (Array.isArray(template)) {
        template.filter((t) => !!t).forEach((t) => fillTemplateInner(item, t));
    } else if (template) {
        if ((template.id || template.alternativeId) && !template.uid) {
            template.uid = nanoid();
        }

        Object.entries(template).forEach(([key, value]) => {
            const typedKey = key as keyof TWidget<TCommonData>;
            if (typeof value === 'string') {
                const newValue = getValueFromItem(item, value);
                (template as Record<string, TCommonWidgetValue>)[typedKey] = newValue ?? value;
            } else if (value) {
                fillTemplateInner(item, value as TWidget<TCommonData>);
            }
        });
    }
    return template;
};
export const fillTemplateInnerForTest = (item: Record<string, TCommonWidgetValue>, template?: Array<TWidget<TCommonData>> | TWidget<TCommonData>) =>
    fillTemplateInner(item, template);
